import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import ModalUPT from "../../registrasi/modal/ModalUPT";
import ModalImg from "../modal/ModalImg";

import { useEditTrader } from "./hooks/useEditTrader.js";
import EditTraderForm from "./components/EditTraderForm.js";
import EditUserForm from "./components/EditUserForm.js";
import VerificationActions from "./components/VerificationActions.js";
import EditAlertManager from "./components/EditAlertManager.js";

const EditTrader = () => {
    const {
        mode,
        trader, setTrader,
        user, setUser,
        propinsi, kota,
        namaUPT, setNamaUPT,
        kodeUPT, setKodeUPT,
        services, setServices,
        showUPT, setShowUPT,
        showImg, setShowImg,
        jenisImg, kdDokumen,
        handleClickImg,
        isReplacingDoc,
        replaceDocument,
        handlePropinsiChange,
        rejectReason, setRejectReason,
        showRejectForm, setShowRejectForm,
        isSubmitting,
        alerts, setAlert,
        saveEditOnly,
        approveVerification,
        rejectVerification,
        handleCloseAfterDone,
        navigate,
    } = useEditTrader();

    const isVerifikasi = mode === "verifikasi";

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card className="px-5 pt-5">
                        <Card.Header>
                            <div className="header-title">
                                <h4 className="card-title">
                                    {isVerifikasi ? "Verifikasi Permohonan Akun" : "Edit Trader"}
                                </h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <h4 className="mb-5 text-center">Data Umum Pengguna Jasa</h4>

                            {/* Mode 'edit' -> submit langsung update, tanpa email.
                                Mode 'verifikasi' -> tombol submit disembunyikan,
                                diganti VerificationActions (approve/reject) di bawah. */}
                            <Form onSubmit={isVerifikasi ? (e) => e.preventDefault() : saveEditOnly}>
                                <EditTraderForm
                                    trader={trader}
                                    setTrader={setTrader}
                                    propinsi={propinsi}
                                    kota={kota}
                                    handlePropinsiChange={handlePropinsiChange}
                                    onViewDoc={handleClickImg}
                                    onReplaceDoc={replaceDocument}
                                    isReplacingDoc={isReplacingDoc}
                                />

                                <h4 className="mb-4 mt-5">Data Pengguna Jasa</h4>

                                <EditUserForm
                                    user={user}
                                    setUser={setUser}
                                    trader={trader}
                                    namaUPT={namaUPT}
                                    services={services}
                                    setServices={setServices}
                                    onClickUPT={() => setShowUPT(true)}
                                    onViewDoc={handleClickImg}
                                    onReplaceDoc={replaceDocument}
                                    isReplacingDoc={isReplacingDoc}
                                />

                                {!isVerifikasi && (
                                    <div className="text-center mt-5">
                                        <Button type="submit" variant="primary" className="me-2" disabled={isSubmitting}>
                                            {isSubmitting ? "Memproses..." : "Update Data"}
                                        </Button>
                                        <Button
                                            type="button"
                                            variant="danger"
                                            onClick={() => navigate("/setting/trader")}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                )}
                            </Form>

                            {isVerifikasi && (
                                <VerificationActions
                                    isSubmitting={isSubmitting}
                                    showRejectForm={showRejectForm}
                                    setShowRejectForm={setShowRejectForm}
                                    rejectReason={rejectReason}
                                    setRejectReason={setRejectReason}
                                    onApprove={approveVerification}
                                    onReject={rejectVerification}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <ModalUPT
                setKodeUPT={setKodeUPT}
                setNamaUPT={setNamaUPT}
                showUPT={showUPT}
                handleCloseUPT={() => setShowUPT(false)}
            />
            <ModalImg
                setJenisImg={jenisImg}
                setKdDokumen={kdDokumen}
                showImg={showImg}
                handleCloseImg={() => setShowImg(false)}
            />

            <EditAlertManager alerts={alerts} setAlert={setAlert} onDone={handleCloseAfterDone} />
        </>
    );
};

export default EditTrader;